import * as fromActions from '../actions';
import * as fromModels from '../../models';

export interface SqlQueryDetailsState {
  loading: boolean;
  loaded: boolean;
  errors: any[];
  queryResonse: fromModels.QueryResponse;
  tableSchemas: fromModels.TableSchema[];
}

export const initialState: SqlQueryDetailsState = {
  loading: false,
  loaded: false,
  errors: null,
  queryResonse: null,
  tableSchemas: []
};

export function reducer(state = initialState, action: fromActions.SqlQueryActions): SqlQueryDetailsState {
  switch (action.type) {
    case fromActions.SqlQueryActionTypes.LoadDatabaseSchemas: {
      return {
        ...state,
        loading: true,
        loaded: false,
        queryResonse: null,
        tableSchemas: [],
        errors: null
      };
    }

    case fromActions.SqlQueryActionTypes.LoadDatabaseSchemasSuccess: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: null,
        queryResonse: null,
        tableSchemas: action.payload
      };
    }

    case fromActions.SqlQueryActionTypes.LoadDatabaseSchemasFailure: {
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.payload,
        queryResonse: null,
        tableSchemas: []
      };
    }

    case fromActions.SqlQueryActionTypes.RunSqlQuery: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case fromActions.SqlQueryActionTypes.RunSqlQueryFailure: {
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.payload
      };
    }

    case fromActions.SqlQueryActionTypes.RunSqlQuerySuccess: {
      console.log('RunSqlQuerySuccess', action.payload);
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: null,
        queryResonse: action.payload
      };
    }

    default: {
      if (Object.values(fromActions.SqlQueryActionTypes).includes((action as fromActions.SqlQueryActions).type)) {
        console.log('sql-query.reducer: unhandled action: ', action);
      }
    }
  }

  return state;
}
